import { Table as ContactsTable } from '@/components/event_contact/table'

interface Props {
  eventId: string
}

export const EditContacts = ({ eventId }: Props) => {
  return (
    <>
      <ContactsTable eventId={eventId} pageSize={10} title="Contacts" createable fixedHeight updateable />
    </>
  )
}
